/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_Type_ValInputs */

const es_cap_jpc_type_val = /** @type {(inputs: Cap_Jpc_Type_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recreo · charter de día`)
};

const gl_cap_jpc_type_val = /** @type {(inputs: Cap_Jpc_Type_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recreo · charter de día`)
};

const en_cap_jpc_type_val = /** @type {(inputs: Cap_Jpc_Type_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leisure · day charter`)
};

/**
* | output |
* | --- |
* | "Leisure · day charter" |
*
* @param {Cap_Jpc_Type_ValInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_type_val = /** @type {((inputs?: Cap_Jpc_Type_ValInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_Type_ValInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_type_val(inputs)
	if (locale === "en") return en_cap_jpc_type_val(inputs)
	return es_cap_jpc_type_val(inputs)
});